{
  "ui": {
    "feedback": "Feedback",
    "credits": "Mitwirkende",
    "currentMaintainer": "Aktuelle Betreuung",
    "maintainerPeriod": "Ab 2026",
    "originalTeam": "Ursprüngliches Team",
    "creditsCampaigns": "Dschungel & Weihnachten",
    "moreSettings": "Weitere Einstellungen",
    "chooseLanguage": "Wähle deine Sprache",
    "notebookTools": "Werkzeuge im Notizbuch",
    "visualGuide": "Bilderanleitung",
    "templeSoon": "Demnächst",
    "playAdventure": "Spielen",
    "story": "Die Geschichte",
    "loadingAdventure": "Wir packen fürs Abenteuer…",
    "storyOpening": "Ein Schulausflug in den Dschungel. Marco und Sophia erkunden ihn mit ihren Freunden. Ein bunter Vogel weckt Marcos Neugier. Er folgt ihm zwischen die Bäume. Plötzlich ist er allein. Hilf den Entdeckern, ihren Weg zu finden!",
    "storyEnding": "Marco und Sophia erreichen gemeinsam den verlorenen Tempel. Ein geheimnisvolles Gesicht bewacht den Eingang. Ein neues Abenteuer wartet!",
    "blockCategories": "Notizbuchreiter",
    "actions": "Aktionen",
    "loops": "Schleifen",
    "conditions": "Bedingungen",
    "title": "Run Marco! — Ein Abenteuer in deinem Notizbuch",
    "home": "Run-Marco-Startseite",
    "map": "Abenteuerkarte",
    "worlds": "Wähle ein Abenteuer",
    "notebook": "Mein Notizbuch",
    "notebookToggle": "Notizbuch öffnen oder schließen",
    "notebookOpen": "Notizbuch öffnen",
    "notebookClose": "Den Weg beobachten",
    "page": "Seite {number}",
    "level": "Pfad {number}",
    "run": "Los geht’s!",
    "stop": "Stopp",
    "step": "Ein Schritt",
    "stepTitle": "Eine Anweisung ausführen",
    "reset": "Zurück zum Start",
    "add": "Hinzufügen",
    "addLabel": "Wähle einen Baustein",
    "addHint": "Verbinde deine Bausteine und drücke Spielen.",
    "undo": "Rückgängig",
    "clear": "Neue Seite",
    "hint": "Ein kleiner Tipp",
    "help": "So geht’s",
    "settings": "Einstellungen",
    "language": "Spielsprache",
    "blockLanguage": "Sprache der Bausteine",
    "blockLanguageNote": "Du kannst für die Bausteine eine andere Sprache wählen.",
    "musicOn": "Ton einschalten",
    "musicOff": "Ton ausschalten",
    "sound": "Musik und Geräusche",
    "speed": "Spielgeschwindigkeit",
    "chooseExplorer": "Wähle deinen Entdecker",
    "explorer": "Entdecker",
    "marco": "Marco",
    "sophia": "Sophia",
    "close": "Schließen",
    "done": "Auf Entdeckungsreise!",
    "loading": "Wir suchen den Weg…",
    "loadError": "Das Abenteuer konnte nicht geladen werden. Lade die Seite neu.",
    "imageError": "Einige Bilder konnten nicht geladen werden. Lade die Seite neu.",
    "gemGoal": "Finde den Edelstein",
    "goal": "Finde den goldenen Stern",
    "cover": "Lass jedes Feld genau einmal leuchten",
    "lit": "{count} / {total} Felder leuchten",
    "explored": "{count} / {total} Pfade erkundet",
    "facing": "Blick nach {direction} {arrow}",
    "boardLabel": "{name} auf {level}, Blick nach {direction}. {steps}. {objective}.",
    "up": "oben",
    "down": "unten",
    "left": "links",
    "right": "rechts",
    "steps_one": "{count} Schritt",
    "steps_other": "{count} Schritte",
    "blocks_one": "{count} Baustein",
    "blocks_other": "{count} Bausteine",
    "stars_one": "{count} Stern",
    "stars_other": "{count} Sterne",
    "place": "Bausteine hinzufügen",
    "atEnd": "Am Ende",
    "insideRepeat": "In Wiederholung {number}",
    "insideIf": "In Wenn {number}",
    "insideElse": "In Sonst {number}",
    "readyFirst": "Ein kleiner Schritt. Füge einen Vorwärts-Baustein hinzu und los geht’s!",
    "ready": "Wohin gehen wir? Plane deinen Weg im Notizbuch.",
    "back": "Zurück am Start. Deine Bausteine sind bereit für einen neuen Versuch.",
    "empty": "Füge zuerst einen Baustein in dein Notizbuch ein.",
    "win": "Du hast den Weg gefunden!",
    "winCover": "Du hast den Pfad zum Leuchten gebracht!",
    "winDetails": "{steps} · {blocks}",
    "brilliant": "Was für ein Abenteuer!",
    "simpler": "Schaffst du es mit weniger Bausteinen?",
    "complete": "Pfad geschafft! Deine besten Sterne sind gespeichert.",
    "next": "Nächster Pfad",
    "allWorlds": "Weitere Abenteuer",
    "replay": "Noch einmal spielen",
    "shortGoal": "Fast! Füge weitere Bausteine hinzu, um den Stern zu erreichen.",
    "shortGem": "Fast! Füge weitere Bausteine hinzu, um den Edelstein zu erreichen.",
    "shortCover": "Einige Felder sind noch dunkel. Wie erreichen wir sie?",
    "checking": "Wir schauen auf den Weg…",
    "paused": "Angehalten. Spielen beginnt wieder von vorn.",
    "going": "Auf geht’s!",
    "stepped": "Ein Schritt näher. Drücke Ein Schritt oder Spielen, um weiterzumachen.",
    "clueCover": "Beginne am Rand und folge der ganzen Form. Ein Sprung überspringt ein Feld, ohne es zum Leuchten zu bringen.",
    "clueCondition": "Schau auf den Weg vor dir. Eine Bedingung hilft deinem Entdecker bei der Entscheidung.",
    "clueRepeat": "Welche Schritte wiederholen sich? Setze dieses Muster in eine Schleife.",
    "clueForward": "Vorwärts folgt der Blickrichtung deines Entdeckers. Zähle die Felder bis zum Stern.",
    "clueGem": "Vorwärts folgt der Blickrichtung deines Entdeckers. Zähle die Felder bis zum Edelstein.",
    "clueTurn": "Drehen ändert nur die Richtung. Fahre den Weg mit dem Finger nach.",
    "mapNote": "Wähle einen Pfad. Deine besten Sterne bleiben gespeichert.",
    "mapLevel": "Pfad {number}: {name}. {stars}.",
    "locked": "Schaffe den vorherigen Pfad, um diesen freizuschalten.",
    "soundBlocked": "Tippe auf den Tonknopf, um das Abenteuer zu hören.",
    "clearTitle": "Eine neue Seite anfangen?",
    "clearNote": "Die Bausteine dieses Pfades werden gelöscht. Rückgängig bringt sie zurück.",
    "keep": "Meine Bausteine behalten",
    "clearConfirm": "Bausteine löschen",
    "fresh": "Eine neue Seite. Wohin führt uns dein nächster Plan?",
    "localProgress": "Dein Fortschritt wird auf diesem Gerät gespeichert.",
    "helpBuild": "Mach einen Plan",
    "helpBuildText": "Ziehe Bausteine ins Notizbuch und verbinde sie, oder tippe sie an. Wähle „In Wiederholung“, um Schritte in eine Schleife einzufügen.",
    "helpTurn": "Folge deinem Entdecker",
    "helpTurnText": "Vorwärts folgt seiner Blickrichtung. Links und rechts drehen ihn auf der Stelle. Ein Sprung reicht über zwei Felder.",
    "helpTry": "Versuchen, beobachten, noch einmal versuchen",
    "helpTryText": "Drücke Spielen für deinen Plan oder Ein Schritt für eine Anweisung. Der gebogene Pfeil bringt dich mit deinen Bausteinen zum Start zurück.",
    "helpWorlds": "Jedes Abenteuer hat ein Ziel",
    "helpWorldsText": "Finde im Dschungel den Edelstein. Beleuchte im Weihnachtsabenteuer jedes freie Feld genau einmal. Erledige im Tempel und in der Ägäis die Reparaturen und sichtbaren Ziele und erreiche den Ausgang.",
    "noTrail": "Dort ist kein Weg! Versuche erst, dich zu drehen.",
    "broken": "Diese Brücke ist kaputt. Kannst du darüber springen?",
    "blocked": "Etwas versperrt den Weg. Versuche einen Sprung oder einen anderen Weg.",
    "alreadyLit": "Dieses Feld leuchtet schon. Besuche jedes Feld nur einmal.",
    "loopError": "Dieser Plan wiederholt sich endlos. Ändere die Schleife.",
    "repeatError": "Wähle eine Wiederholungszahl zwischen 1 und 99.",
    "unsupported": "Entferne den nicht unterstützten Baustein und versuche es erneut.",
    "connect": "Verbinde die Bausteine zu einer Kette und drücke Spielen.",
    "path": "Weg",
    "backpack": "Rucksack",
    "templeGems": "Edelsteine des Tempels",
    "gemsCollected": "Edelsteine: {count} / {total}",
    "gemsReady": "Alle Edelsteine sind gesammelt!",
    "aegeanTitle": "Die Geheimnisse der Ägäis",
    "harbour": "Hafen",
    "aegeanDescription": "Erkunde den Hafen: Repariere Stationen, verwende Routinen erneut und übergib jedem Auftrag eine Zahl.",
    "templeBetaNote": "Beta · Rätsel und Lektionen werden überarbeitet",
    "aegeanBetaNote": "Beta · Die ersten 3 Hafenlevel",
    "seasonal": "Saisonabenteuer",
    "choosePreview": "Wähle ein Vorschaulevel",
    "repairs": "Reparaturen",
    "reachExit": "Erreiche den Ausgang",
    "taskRequirements": "Missionsziele",
    "lessonGuided": "Angeleitete Übung · vervollständige das vorgegebene Programm",
    "lessonRepair": "Fehlersuche · korrigiere das vorgegebene Programm",
    "lessonChallenge": "Herausforderung · erstelle dein eigenes Programm",
    "acc_define_parameter": "Routine",
    "acc_call_argument": "Routine aufrufen",
    "acc_repeat_parameter": "Mit Eingabe wiederholen",
    "parameter": "Parameter",
    "argument": "übergeben",
    "callInput": "Eingabe dieses Aufrufs",
    "inputWaiting": "Starte das Programm oder führe einen Einzelschritt aus, um die nächste Eingabe zu sehen.",
    "argumentMismatch": "Eine Routine mit Parameter braucht einen Aufruf mit einer Zahl. Ohne Parameter genügt ein gewöhnlicher Aufruf.",
    "unsetParameter": "Verwende den Parameter nur in der Routine, die ihn empfängt. Parameter sind vom gemeinsamen Speicher getrennt.",
    "memoryObjective": "Prüfe das Reparaturprotokoll und die Ausgangsziele. Jedes Programm, das sie erfüllt, wird akzeptiert.",
    "gate": "Der Weg ist versperrt. Prüfe die offenen Reparaturen.",
    "noPickup": "Stelle dich auf das Werkzeug, bevor du es aufhebst.",
    "creditLead": "Teamleitung und Softwareentwicklung",
    "creditArt": "Illustration und Kulissen",
    "creditAnimation": "Animation",
    "creditUX": "Oberflächen- und Nutzererlebnisdesign",
    "creditDesign": "Spieldesign",
    "creditStory": "Geschichte",
    "creditAudio": "Musik und Tontechnik",
    "lightLamp": "Lampe anzünden",
    "oilLamp": "Öllampe",
    "dustyStation": "staubige Station",
    "betaLabel": "Beta",
    "noLamp": "Stell dich auf eine unbeleuchtete Lampe, bevor du sie anzündest.",
    "collected": "Werkzeug eingesammelt · einsatzbereit",
    "dustyPrompt": "Stell dich auf eine staubige Station, bevor du den Pinsel benutzt.",
    "lampMissing": "Sammle zuerst die Öllampe ein. Schau in deinen Rucksack.",
    "recursiveRoutine": "Diese Routine ruft sich selbst auf. Nutze eine andere Routine; rekursive Aufrufe sind noch nicht verfügbar."
  },
  "content": {
    "jungle.title": "Dschungelexpedition",
    "jungle.description": "Folge dem Pfad zum verlorenen Tempel.",
    "jungle-1": "Erste Schritte",
    "jungle-2": "Ein Stück weiter",
    "jungle-3": "Um die Ecke",
    "jungle-4": "Ändere die Richtung",
    "jungle-5": "Folge dem Pfad",
    "jungle-6": "Ein neuer Weg",
    "jungle-7": "Neue Pfade",
    "jungle-8": "Dschungelkreuzung",
    "jungle-9": "Finde deinen Weg",
    "jungle-10": "Denke voraus",
    "jungle-11": "Der lange Pfad",
    "jungle-12": "Ein kurviger Weg",
    "jungle-13": "Ein mutiger Sprung",
    "jungle-14": "Muster tauchen auf",
    "jungle-15": "Wiederhole den Rhythmus",
    "jungle-16": "Wähle einen Pfad",
    "jungle-17": "Schau vor dem Sprung",
    "jungle-18": "Lies den Weg",
    "jungle-19": "Ein schlauer Umweg",
    "jungle-20": "Unter den Baumkronen",
    "jungle-21": "Brückenbauer",
    "jungle-22": "Jenseits des Flusses",
    "jungle-23": "Erkunde die Ruinen",
    "jungle-24": "Stein und Holz",
    "jungle-25": "Ein größerer Sprung",
    "jungle-26": "Folge den Hinweisen",
    "jungle-27": "Weiter hinauf",
    "jungle-28": "Entdecke weiter",
    "jungle-29": "Verschlungene Pfade",
    "jungle-30": "Der geheime Garten",
    "jungle-31": "Versteckte Muster",
    "jungle-32": "Uralte Wege",
    "jungle-33": "Die letzten Kurven",
    "jungle-34": "Zum Tempel",
    "jungle-35": "Fast geschafft",
    "jungle-36": "Der verlorene Tempel",
    "winter.title": "Winterpfad",
    "winter.description": "Lass jeden Fußabdruck leuchten.",
    "winter-1": "Schritte im Schnee",
    "winter-2": "Eine andere Richtung",
    "winter-3": "Gefrorene Ecken",
    "winter-4": "Der lange Umweg",
    "winter-5": "Schneeflocke",
    "winter-6": "Winterschleifen",
    "winter-7": "Eisentdecker",
    "winter-8": "Kurven und Wendungen",
    "winter-9": "Eisige Logik",
    "winter-10": "Musterfinder",
    "winter-11": "Meister des Pfades",
    "winter-12": "Winterwunder",
    "temple.title": "Der verlorene Tempel",
    "temple.description": "Vierzig verbundene Räume: Stelle mit Werkzeugen, Speicher und eigenen Routinen ein Himmelsinstrument wieder her."
  },
  "blockly": {
    "ARIA_LABEL_TRASH_EMPTY": "Papierkorb, derzeit leer",
    "OPEN_TRASH": "Papierkorb öffnen",
    "BLOCK_LABEL_BEGIN_STACK": "Anfang des Stapels",
    "WORKSPACE_LABEL_1_STACK": "1 Bausteinstapel",
    "WORKSPACE_LABEL_MANY_STACKS": "%1 Bausteinstapel",
    "ARIA_TYPE_FIELD_NUMBER": "Zahl",
    "ARIA_TYPE_FIELD_DROPDOWN": "Auswahlliste",
    "ARIA_TYPE_FIELD_IMAGE": "Bild",
    "WORKSPACE_LABEL_PLAIN": "Mein Notizbuch",
    "FIELD_LABEL_EDIT_PREFIX": "%1 bearbeiten",
    "BLOCK_LABEL_HAS_INPUT": "hat eine Eingabe",
    "BLOCK_LABEL_HAS_INPUTS": "hat Eingaben",
    "BLOCK_LABEL_HAS_BRANCHES": "hat %1 Zweige",
    "FIELD_LABEL_OPTION_INDEX": "Option %1",
    "INPUT_LABEL_EMPTY": "Leer",
    "BLOCK_LABEL_DISABLED": "deaktiviert",
    "BLOCK_LABEL_COLLAPSED": "eingeklappt",
    "BLOCK_LABEL_BEGIN_PREFIX": "Anfang: %1",
    "INPUT_LABEL_END_STATEMENT": "Ende: %1",
    "ARIA_TYPE_FIELD_TEXT_INPUT": "Text",
    "ARIA_TYPE_FIELD_INPUT": "Eingabe",
    "ARIA_TYPE_FIELD_TEXT_INPUT_ARGUMENT": "Name der Eingabe",
    "ARIA_TYPE_FIELD_TEXT_INPUT_PROCEDURE": "Name der Routine"
  }
}
